import { useEffect, useRef } from 'react';

const SSE_BASE = '/movies-api';

/**
 * useCrawlEvents — subscribes to the SSE stream and calls
 * onHomeRefresh() whenever the backend broadcasts a home-refresh event.
 */
export function useCrawlEvents(onHomeRefresh) {
    const onHomeRefreshRef = useRef(onHomeRefresh);

    useEffect(() => {
        onHomeRefreshRef.current = onHomeRefresh;
    }, [onHomeRefresh]);

    useEffect(() => {
        const sessionId = `client-${Date.now()}-${Math.random().toString(36).slice(2)}`;
        const url = `${SSE_BASE}/api/v1/events/subscribe?sessionId=${sessionId}`;
        console.log('[SSE] Connecting to:', url);

        const es = new EventSource(url);

        es.addEventListener('home-refresh', () => {
            console.log('[SSE] Received home-refresh event');
            onHomeRefreshRef.current?.();
        });

        es.addEventListener('crawl-update', (e) => {
            try {
                const data = JSON.parse(e.data);
                console.log('[SSE] crawl-update:', data);
            } catch {}
        });

        es.onerror = (err) => {
            console.log('[SSE] Error, reconnecting...', err);
        };

        return () => {
            es.close();
        };
    }, []);
}
